import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';

const modalSlice = createSlice({
    name: 'modalSlice',
    initialState,
    reducers: {
        openWarningModal: (state, action: PayloadAction<string>) => {
            state.warningModal.isOpen = true;
            state.warningModal.text = action.payload;
        },
        closeWarningModal: state => {
            state.warningModal.isOpen = false;
            state.warningModal.text = '';
        },
        openWithTitleModal: (state, action: PayloadAction<any>) => {
            state.confirmModal = {
                isOpen: true,
                cancelButtonContents: '취소',
                confirmButtonContents: '확인',
                contents: 'dd',
                onClickCancelButton: action.payload.onClickCancelButton,
                onClickConfirmButton: action.payload.onClickConfirmButton,
                title: '',
            };
        },
        toggleProgressModal: state => {
            state.progressModal = !state.progressModal;
        },
    },
});

export const { openWarningModal, closeWarningModal, openWithTitleModal, toggleProgressModal } = modalSlice.actions;
export default modalSlice.reducer;
